import React from 'react';
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  IconButton
} from '@mui/material';
import Sidebar from '../../../Navigation/Sidebar/Sidebar';
import VisibilityIcon from '@mui/icons-material/Visibility';
import './PostBills.css';

const PostBillsComponent = ({ activeBills, closedBills, loading, handleGoBack, viewInactiveBillDetails }) => {
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      });
    } catch {
      return dateString;
    }
  };

  // Check if there are any bills
  const hasBills = closedBills && closedBills.length > 0;

  return (
    <div className="pbb-layout">
      <Sidebar />
      <div className="pbb-container">
        {/* Header Section */}
        <div className="pbb-header-wrapper">
          <button className="pbb-back-btn" onClick={handleGoBack}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="15 18 9 12 15 6"></polyline>
            </svg>
          </button>
          <div className="pbb-header-content">
            <Typography variant="h4" className="pbb-title">
              Past Bills
            </Typography>
            <Typography className="pbb-subtitle">
              View all closed bills for this partner
            </Typography>
          </div>
          {hasBills && (
            <div className="pbb-bill-count">
              <span className="pbb-count-number">{closedBills.length}</span>
              <span className="pbb-count-label">Bills</span>
            </div>
          )}
        </div>

        {loading ? (
          <div className="pbb-loading-container">
            <CircularProgress className="pbb-loader" />
            <Typography className="pbb-loading-text">Loading bills...</Typography>
          </div>
        ) : (
          <div className="pbb-table-section">
            <TableContainer component={Paper} className="pbb-table-container">
              <Table stickyHeader className="pbb-table">
                <TableHead>
                  <TableRow className="pbb-table-header-row">
                    <TableCell className="pbb-header-cell pbb-header-bill-id">Bill ID</TableCell>
                    <TableCell className="pbb-header-cell pbb-header-start-date">Start Date</TableCell>
                    <TableCell className="pbb-header-cell pbb-header-end-date">End Date</TableCell>
                    <TableCell className="pbb-header-cell pbb-header-actions">Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className="pbb-table-body">
                  {hasBills ? (
                    closedBills.map((bill, index) => (
                      <TableRow 
                        key={bill.billId || index} 
                        className="pbb-table-row"
                        hover
                      >
                        <TableCell className="pbb-cell pbb-cell-bill-id">
                          <span className="pbb-bill-id-badge">{bill.billId}</span>
                        </TableCell>
                        <TableCell className="pbb-cell pbb-cell-start-date">
                          <span className="pbb-date-text">{formatDate(bill.startDate)}</span>
                        </TableCell>
                        <TableCell className="pbb-cell pbb-cell-end-date">
                          <span className="pbb-date-text">{formatDate(bill.endDate)}</span>
                        </TableCell>
                        <TableCell className="pbb-cell pbb-cell-actions">
                          <IconButton 
                            onClick={() => viewInactiveBillDetails(bill.billId)} 
                            className="pbb-view-btn"
                            size="small"
                            title="View Bill Details"
                          >
                            <VisibilityIcon fontSize="small" />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow className="pbb-empty-row">
                      <TableCell colSpan={4} className="pbb-empty-cell">
                        <div className="pbb-empty-state">
                          <svg className="pbb-empty-icon" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#c1c9d6" strokeWidth="1.5">
                            <rect x="2" y="3" width="20" height="18" rx="2" ry="2"></rect>
                            <line x1="8" y1="21" x2="16" y2="21"></line>
                            <line x1="12" y1="17" x2="12" y2="21"></line>
                            <line x1="4" y1="7" x2="20" y2="7"></line>
                          </svg>
                          <Typography className="pbb-empty-title">No Closed Bills</Typography>
                          <Typography className="pbb-empty-subtitle">There are no closed bills available for this partner</Typography>
                        </div>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}
      </div>
    </div>
  );
};

export default PostBillsComponent;